import {
    switchMap,
    distinctUntilChanged,
    debounceTime,
    filter,
} from 'rxjs/operators';
import { TranslatePipe } from '@ngx-translate/core';
import {
    AfterViewInit,
    Component,
    ElementRef,
    OnInit,
    ViewChild,
} from '@angular/core';
import { StudentsFirstnameLastnameCompanyNamePipe } from '../../_shared/students-firstname-lastname-companyname.pipe';
import { Student, StudentService } from '../../../_services';
import { Subject } from 'rxjs';

@Component({
    selector: 'students',
    templateUrl: 'student.component.html',
    styleUrls: ['student.component.scss'],
    providers: [TranslatePipe, StudentsFirstnameLastnameCompanyNamePipe],
})
export class StudentComponent implements OnInit, AfterViewInit {
    private static _search: string = '';
    private static _students: Student[] = [];

    @ViewChild('searchInput')
    private searchInput: ElementRef;

    account: any;
    error: string;
    success: string;
    active: boolean = true;

    searchStudentsSubject = new Subject<string>();

    constructor(private studentService: StudentService) {}

    get search(): string {
        return StudentComponent._search;
    }

    set search(search: string) {
        StudentComponent._search = search;
    }

    get students(): Student[] {
        return StudentComponent._students;
    }

    set students(students: Student[]) {
        StudentComponent._students = students;
    }

    ngOnInit() {
        this.searchStudentsSubject
            .pipe(
                filter((keyword) => keyword.length >= 2),
                debounceTime(500),
                distinctUntilChanged(),
                switchMap((search: string) =>
                    this.studentService.findBySearch(search.toLowerCase())
                )
            )
            .subscribe((students) => (this.students = students));
    }

    ngAfterViewInit(): void {
        this.searchInput.nativeElement.focus();
    }

    searchStudents() {
        this.searchStudentsSubject.next(this.search);
    }
}



// WEBPACK FOOTER //
// ./src/app/_screens/directory/student/student.component.ts